import(/* webpackMode: "eager" */ "/home/runner/work/searchright-0.1-fe/searchright-0.1-fe/src/app/global-error.tsx");
